import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAppApiClient } from "../../hooks/useAppApiClient";
import { AppLinks } from "../../links";
import { Loader } from "../../components/loader/Loader";
import { TermsAndConditionsDialog } from "./components/dialogs/TermsAndConditionsDialog";
import { useAuthentication } from "../../hooks/useAuthentication";

interface Props {
  links: AppLinks;
}

export const HomeRedirect = ({ links }: Props) => {
  const api = useAppApiClient();
  const [loading, setLoading] = useState(true);
  const [needsTerms, setNeedsTerms] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const { logOut } = useAuthentication();

  useEffect(() => {
    const checkTerms = async () => {
      const user = await api.getCurrentUser();
      if (user?.TermsAccepted) {
        setAccepted(true);
      } else {
        setNeedsTerms(true);
      }
      setLoading(false);
    };

    checkTerms();
  }, [api]);

  const handleAccept = async () => {
    await api.acceptTerms();
    setAccepted(true);
  };

  if (loading) return <Loader />;
  if (accepted) return <Navigate to={links.chatbot()} replace />;

  return needsTerms ? (
    <TermsAndConditionsDialog
      open={needsTerms && !accepted}
      onAccept={handleAccept}
      onCancel={logOut}
    />
  ) : null;
};
